import classNames from 'clsx'
import { arrayOf, func, shape } from 'prop-types'

import ButtonFilter from 'views/components/molecules/ButtonFilter'
import { interact } from 'views/components/organisms/AlgoliaInstantSearch/Algolia/helpers'

import './SortByMobile.scss'

const renderOptions = (items, refine) =>
  items.map((item, index) => {
    const key = item.value

    return (
      <li
        key={key}
        className={classNames({ 'u-margin--right': index + 1 < items.length })}
      >
        <ButtonFilter
          name={key}
          transparent
          ariaPressed={item.isRefined ? 'true' : 'false'}
          onClick={interact(refine, key)}
        >
          <span className="u-no-wrap">{item.label}</span>
        </ButtonFilter>
      </li>
    )
  })

const SortByMobile = ({ items, refine }) => (
  <div className="o-SortByMobile u-background-color--greyLight-light">
    <ul className="o-SortByMobile__list a-list-reset u-padding l-flex">
      {renderOptions(items, refine)}
    </ul>
  </div>
)

SortByMobile.propTypes = {
  items: arrayOf(shape({})).isRequired,
  refine: func.isRequired,
}

export default SortByMobile
